import React from 'react'
import './profileuserbarspacer.css'

const ProfileUserBarSpacer = () => {
  return (
    <div className='profile-user-bar-spacer'>&nbsp;</div>
  )
}

export default ProfileUserBarSpacer 